const defaultHeaders = new Headers({
  "X-Requested-With": "XMLHttpRequest",
});

function toQueryString(params) {
  return Object.entries(params).map((parts) => parts.map(encodeURIComponent).join("="));
}

export function fetchURL(url, fetchArgs) {
  fetchArgs = fetchArgs || {};
  if (fetchArgs.queryParams) {
    url += (url.includes("?") ? "&" : "?") + toQueryString(fetchArgs.queryParams);
  }

  return fetch(url, {
    headers: defaultHeaders,
    ...fetchArgs,
  });
}
